import React from "react";

const LoadingGoogleMaps = () => <div className="google-maps-loading"></div>;

export default LoadingGoogleMaps;
